import React from "react";
import Grid from "@material-ui/core/Grid";

const LinksList = () => {
  return (
    <React.Fragment>
      <Grid item xs={12} sm={6}>
        <ul>
          <li>
            <a
              href="https://www.aqr.com/Insights/Research/Alternative-Thinking/2021-Capital-Markets-Assumptions-for-Major-Asset-Classes"
              target="_blank"
              rel="noopener noreferrer"
            >
              AQR Capital Management
            </a>
          </li>
          <li>
            <a
              href="https://www.blackrock.com/institutions/en-us/insights/charts/capital-market-assumptions"
              target="_blank"
              rel="noopener noreferrer"
            >
              BlackRock
            </a>
          </li>
          <li>
            <a
              href="https://www.bmo.com/gam/ca/institutional/news-and-insights/articles/capital-market-assumptions"
              target="_blank"
              rel="noopener noreferrer"
            >
              BMO Global Asset Management
            </a>
          </li>
          <li>
            <a
              href="https://www.bnymellonwealth.com/articles/strategy/our-2021-capital-market-assumptions.jsp"
              target="_blank"
              rel="noopener noreferrer"
            >
              BNY Mellon
            </a>
          </li>
          <li>
            <a
              href="https://www.investpmc.com/sites/default/files/documents/PMC_CapitalMarketsAssumptions_Update.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Envestnet PMC
            </a>
          </li>
          <li>
            <a
              href="https://www.invesco.com/content/dam/invesco/apac-master/en/pdf/apac/2020/solutions/2021-LTCMA-USD.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Invesco
            </a>
          </li>
          <li>
            <a
              href="https://am.jpmorgan.com/content/dam/jpm-am-aem/global/en/insights/portfolio-insights/ltcma/ltcma-full-report.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              JPMorgan
            </a>
          </li>
          <li>
            <a
              href="https://www.mfs.com/content/dam/mfs-enterprise/mfscom/insights/2021/october/mfse_fly_1009928.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              MFS
            </a>
          </li>
        </ul>
      </Grid>
      <Grid item xs={12} sm={5}>
        <ul>
          <li>
            <a
              href="https://www.pgim.com/market-outlooks?utm_medium=cpc&utm_source=GOOGLE&utm_campaign=PGIM%20Center_B2B_Unkwn_Management_Investment_Brand_BMM_US&ds_cid=71700000072135037&utm_content=PC%20-%20Investment%20Manager&ds_agid=58700006319567484&utm_term=%2Bprudential%20%2Binvestment%20%2Bmanagement&ds_kid=43700057051406291&matchtype=b&network=g&adposition=&gclid=EAIaIQobChMImfPsnpbX8wIVgD6tBh3LJgrkEAAYASABEgIwe_D_BwE&gclsrc=aw.ds"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prudential Investment Management Services LLC
            </a>
          </li>
          <li>
            <a
              href="https://www.rbccm.com/en/insights.page"
              target="_blank"
              rel="noopener noreferrer"
            >
              RBC
            </a>
          </li>
          <li>
            <a
              href="https://interactive.researchaffiliates.com/asset-allocation#!/?currency=USD&amp;model=ER&amp;scale=LINEAR&amp;terms=RE"
              target="_blank"
              rel="noopener noreferrer"
            >
              Research Affiliates
            </a>
          </li>
          <li>
            <a
              href="https://www.ssga.com/library-content/pdfs/insights/forecasts-quarterly-q4-2021.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              State Street
            </a>
          </li>
          <li>
            <a
              href="https://www.troweprice.com/content/dam/ide/articles/pdfs/2021/q1/capital-market-assumptions.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              T. Rowe Price
            </a>
          </li>
          <li>
            <a
              href="https://www.ubs.com/global/en/asset-management/insights/capital-market-assumptions/looking-ahead/capital-market-assumptions-update.html?caasID=CAAS-ActivityStream"
              target="_blank"
              rel="noopener noreferrer"
            >
              UBS
            </a>
          </li>
          <li>
            <a
              href="https://pressroom.vanguard.com/nonindexed/Vanguard-economic-and-market-outlook-report-2021-120920.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vanguard
            </a>
          </li>
          <li>
            <a
              href="https://advisors.voya.com/insights/market-insights/2021-capital-market-assumptions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Voya
            </a>
          </li>
        </ul>
      </Grid>
    </React.Fragment>
  );
};

export default LinksList;
